import React, { useState, useEffect, Fragment, useRef } from "react";
import { Link, useNavigate } from "react-router";
import Loader from "../../shared/loader/loader";
import SelectPageSize from "../../shared/common/pageSizeDropdown";
import DeleteModal from "../../shared/common/deleteModal";
import Pagination from "../../shared/common/pagination";
import Select from "react-select";
import {
  getAllPassages,
  getPassagesCategoryOld,
  getPassagesCategory,
  getPassagessourceType,
  getPassagesdifficultyType,
  getPassagesliteratureType,
  getPassagesDataType,
  deletePassage,
  getPassagesGrammarType,
  getClassifications,
} from "../../../api/passage.service";
import { getAllgrade } from "../../../api/grade.service";
import {
  AddIcon,
  FilterIcon,
  EditIcon,
  DeleteIcon,
  ResetIcon,
  CaretUpSolidIcon,
  CaretDownSolidIcon,
  ApproveIcon,
  Disapprove,
  CSVIcon,
} from "../../../assets/icons/index";
import constant from "../../../utils/constant";
import { ISelectElement } from "../../../model/interface/keyValuePair";
import { TreeSelect } from "antd";
import Tooltip from "../../shared/common/ellipsisText";
import { Ipassage } from "../../../model/interface/passage";
import ExportToCSV from "../../shared/common/exportToCsv";
import { DotsVerticalIcon } from "@heroicons/react/solid";
import { Menu, Transition } from "@headlessui/react";
import { TagColor } from "../../../model/tagColor";
import TagSelector, { TagSelectorMode } from "../../shared/common/tagSelector";
import AllowedTo from "../../shared/common/rbac";
import Permissions from "../../../utils/permissions";
import AccessDenied from "../../shared/common/accessDenied";
import MultiStateButton from "../../shared/common/multiStateButton";

function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}
const activeMultiState = [
  { label: "Active", value: true },
  { label: "Both", value: null, selected: true },
  { label: "Inactive", value: false },
];

const Passage = () => {
  const defaultPageNumber = 1;
  const defaultPageSize = 100;
  const [showDeleteModal, setShowDeleteModal] = useState<boolean>(false);
  const [grade, setGrade] = useState<ISelectElement[]>([]);
  const [passageType, setPassageType] = useState<ISelectElement[]>([]);
  const [passageList, setPassageList] = useState<any>([]);
  const [categoryOld, setcategoryOld] = useState<ISelectElement[]>([]);
  const [category, setCategory] = useState<ISelectElement[]>([]);
  const [sourceType, setSourceType] = useState<ISelectElement[]>([]);
  const [difficultyType, setDifficultyType] = useState<ISelectElement[]>([]);
  const [literatureType, setLiteratureType] = useState<ISelectElement[]>([]);
  const [grammarType, setGrammarType] = useState<ISelectElement[]>([]);
  const [dataType, setDataType] = useState<ISelectElement[]>([]);
  const [deleteContent, setDeleteContent] = useState<any>(null);
  const [loading, setLoading] = useState<boolean>(false);
  const [filterTitle, setFilterTitle] = useState<string>("");
  const [filterCitation, setFilterCitation] = useState<string>("");
  const [filterGrade, setFilterGrade] = useState<string>("");
  const [orderByColumn, setOrderByColumn] = useState<string>("name");
  const [pageNumber, setPageNumber] = useState(defaultPageNumber);
  const [pageSize, setPageSize] = useState(defaultPageSize);
  const [totalPages, setTotalPages] = useState(0);
  const [sortByDesc, setSortByAsc] = useState<boolean>(true);
  const [isApproved, setIsApproved] = useState<boolean>(true);
  const [isActive, setIsActive] = useState<boolean | undefined>(undefined);
  const defaultValue = { label: "", value: "0" };
  const defaultElement = [{ label: "Select", value: "0" }];
  const [selectedGrade, setSelectedGrade] = useState(defaultValue);
  const [selectedPassageType, setSelectedPassageType] = useState(defaultValue);
  const [selectedDataType, setSelectedDataType] = useState(defaultValue);
  const [selectedSourceType, setSelectedSourceType] = useState(defaultValue);
  const [selectedGrammar, setSelectedGrammar] = useState(defaultValue);
  const [selectedLiterature, setSelectedLiterature] = useState(defaultValue);
  const [selectedDifficulty, setSelectedDifficulty] = useState(defaultValue);
  const [selectedCategory, setSelectedCategory] = useState<any>({
    title: "",
    key: "",
    value: "",
  });
  const [selectedCategoryOld, setSelectedCategoryOld] = useState(defaultValue);
  const [filterPassageId, setFilterPassageId] = useState<number>();
  const paginationRef: any = useRef(undefined);
  const pageSizeRef: any = useRef(undefined);
  const [isLoaded, setIsLoaded] = useState<boolean>(false);
  const [categoryTypeData, setCategoryTypeData] = useState<any>([]);
  const [totalRecords, setTotalRecords] = useState<number>(0);
  const [isFilter, setIsFilter] = useState<boolean>(false);
  const childRef: any = useRef(undefined);
  const [classification, setClassification] = useState<number | undefined>(0);
  const [selectedClassification, setSelectedClassification] =
    useState(defaultValue);
  const [passageClassification, setPassageClassification] = useState([]);
  const [selectedTagIds, setSelectedTagIds] = useState<Array<number>>([]);
  const [resetDropdownFlag, setResetDropdownFlag] = useState<boolean>(false);
  const [selectedContentArea, setselectedContentArea] = useState(defaultValue);
  const [contentArea, setContentArea] = useState([]);
  const [isInitialLoad, setIsInitialLoad] = useState<boolean>(true);
  const [filterEnglishPassageText, setFilterEnglishPassageText] =
    useState<string>("");
  const navigate = useNavigate();

  const handleDeletePassage = (e, id, userId) => {
    e.preventDefault();
    setShowDeleteModal(true);
    const deleteContent = passageList.find(
      (passage) => passage.passageId === id && passage.userId === userId
    );
    setDeleteContent(deleteContent);
  };

  const deleteRecordHandler = () => {
    deletePassage(deleteContent.passageId, deleteContent.userId);
    setShowDeleteModal(false);
    passageListReload();
  };

  const closeDeleteModal = () => {
    setShowDeleteModal(false);
  };

  const filterTitleChangeHandler = (e) => {
    setFilterTitle(e.target.value);
    if (e.target.value === "") {
      bindPassage();
    }
  };

  const filterEnglishPassageTextChangeHandler = (e) => {
    setFilterEnglishPassageText(e.target.value);
    if (e.target.value === "") {
      bindPassage();
    }
  };

  const handlePassageClassificationChange = (e) => {
    setClassification(undefined);
    if (e) {
      setClassification(e.value);
      setSelectedClassification(e);
    }
  };
  const citationChangeHandler = (e) => {
    setFilterCitation(e.target.value);
    if (e.target.value === "") {
      bindPassage();
    }
  };

  const handleDataTypeChange = (selectedItem) => {
    setSelectedDataType(selectedItem);
  };

  const handleSourceTypeChange = (selectedItem) => {
    setSelectedSourceType(selectedItem);
  };
  const handleDifficultyChange = (selectedItem) => {
    setSelectedDifficulty(selectedItem);
  };
  const handleLiteratureChange = (selectedItem) => {
    setSelectedLiterature(selectedItem);
  };
  const handleGrammarChange = (selectedItem) => {
    setSelectedGrammar(selectedItem);
  };
  const handleGradeChange = (selectedItem) => {
    setSelectedGrade(selectedItem);
  };
  const handlePassageTypeChange = (selectedItem) => {
    setSelectedPassageType(selectedItem);
  };
  const handleCategoryChange = (selectedItem) => {
    const selectedItemData: any = categoryTypeData.filter(
      (ds) => ds.value === selectedItem
    );
    setSelectedCategory(selectedItemData[0]);
  };
  const handleCategoryOldChange = (selectedItem) => {
    setSelectedCategoryOld(selectedItem);
  };

  const approvedChangeHandler = () => {
    setIsApproved(!isApproved);
  };
  const activeChangeHandler = () => {
    setIsActive(!isActive);
  };

  const filterHandler = (e) => {
    setIsInitialLoad(false);
    e.preventDefault();
    filterPassage(false, true, true);
  };

  const filterPassage = (resetObj?, onFilter?, isFilterClick?) => {
    if (isInitialLoad && !isFilterClick) {
      return false;
    }

    setLoading(true);
    if (onFilter) setIsFilter(true);

    const passageData: any = {
      filterTitle: filterTitle,
      filterCitation: filterCitation,
      filterGradeId: selectedGrade !== null ? selectedGrade?.value : "0",
      filterDataType: selectedDataType !== null ? selectedDataType?.value : "0",
      filterSourceType:
        selectedSourceType !== null ? selectedSourceType?.value : "0",
      filterDifficulty:
        selectedDifficulty !== null ? selectedDifficulty?.value : "0",
      filterLiterature:
        selectedLiterature !== null ? selectedLiterature?.value : "0",
      filterGrammar: selectedGrammar !== null ? selectedGrammar?.value : "0",

      filterGrade: filterGrade === "" ? "0" : filterGrade,
      filterCategory:
        selectedCategory !== null ? selectedCategory?.passageCategoryId : "0",
      filterCategoryOld:
        selectedCategoryOld !== null ? selectedCategoryOld?.value : "0",
      orderByColumn: orderByColumn,
      sortByDesc: sortByDesc ? "ASC" : "DESC",
      pageSize: onFilter ? defaultPageSize : pageSize,
      pageNumber: onFilter ? defaultPageNumber : pageNumber,
      isApproved: isApproved,
      isActive: isActive,
      passageId: filterPassageId,
      passageClassificationId: classification,
      tagIds: selectedTagIds.toString(),
      filterPassageTypeId:
        selectedPassageType !== null ? selectedPassageType?.value : "0",
      contentAreaId: selectedContentArea?.value
        ? selectedContentArea?.value
        : undefined,
      filterEnglishPassageText: filterEnglishPassageText,
    };

    getAllPassages(passageData).then((response: any) => {
      setPassageList(response.data.data);
      setTotalPages(Math.ceil(response.data.totalRecords / defaultPageSize));
      setTotalRecords(response.data.totalRecords);
      if (onFilter) {
        paginationRef?.current?.onReset();
        pageSizeRef?.current?.onReset();

        setIsFilter(false);
      }
      setLoading(false);
    });
  };

  async function bindPassage(isReset?) {
    if (isInitialLoad) {
      return false;
    }

    setLoading(true);
    const passageData: any = {
      filterTitle: "",
      filterCitation: "",
      filterGradeId: "0",
      filterDataType: "0",
      filterSourceType: "0",
      filterDifficulty: "0",
      filterLiterature: "0",
      filterGrammar: "0",
      filterGrade: "0",
      filterCategory: "0",
      filterCategoryOld: "0",
      orderByColumn: orderByColumn,
      sortByDesc: sortByDesc ? "ASC" : "DESC",
      pageSize: isReset ? defaultPageSize : pageSize,
      pageNumber: isReset ? defaultPageNumber : pageNumber,
      isApproved: isReset ? true : isApproved,
      isActive: isReset ? undefined : isActive,
      passageId: isReset ? 0 : filterPassageId,
      passageClassificationId: isReset ? undefined : classification,
      filterEnglishPassageText: "",
    };

    getAllPassages(passageData).then((response: any) => {
      setPassageList(response.data.data);
      setTotalPages(
        Math.ceil(
          response.data.totalRecords / (isReset ? defaultPageSize : pageSize)
        )
      );
      setTotalRecords(response.data.totalRecords);
      setLoading(false);
    });
  }

  const handleSortBy = (column: string) => {
    setSortByAsc(!sortByDesc);
    setOrderByColumn(column);
    bindAPI(column);
  };

  const bindAPI = (column: string) => {
    const passageData: any = {
      filterTitle: "",
      filterCitation: "",
      filterGradeId: "0",
      filterDataType: "0",
      filterSourceType: "0",
      filterDifficulty: "0",
      filterLiterature: "0",
      filterGrammar: "0",
      filterGrade: "0",
      filterCategory: "0",
      filterCategoryOld: "0",
      orderByColumn: column,
      sortByDesc: !sortByDesc ? "ASC" : "DESC",
      isApproved: isApproved,
      isActive: isActive,
      pageSize: pageSize,
      pageNumber: pageNumber,
      passageClassificationId: classification,
      filterEnglishPassageText: "",
    };
    getAllPassages(passageData).then((response) => {
      setPassageList(response.data.data);
      setTotalRecords(response.data.totalRecords);
    });
  };

  const handleRedirect = (passage?: Ipassage) => {
    navigate(
      passage
        ? constant.EDITPASSAGE?.replace(":id", passage.passageId.toString())
        : constant.ADDPASSAGE,
      { state: { objectToEdit: passage?.passageId } }
    );
  };

  const gradeRedirect = (gradeId: string) => {
    navigate(
      grade
        ? constant.EDITGRADE.replace(":id", gradeId ? gradeId.toString() : "")
        : constant.ADDGRADE,
      { state: { objectToEdit: grade } }
    );
  };

  const passageListReload = () => {
    bindPassage();
  };

  function bindGrade() {
    getAllgrade().then((response) => {
      let newGrade = [];
      if (response.data.data.length > 0) {
        newGrade = response.data.data.map((element) => {
          return {
            value: element.gradeId || 0,
            label: `${element.name}`,
          };
        });
      }
      setGrade(newGrade);
    });
  }
  function bindPassageType() {
    const passageTypes = constant.PASSAGETYPE;
    const newPassageType: ISelectElement[] = [];
    if (passageTypes) {
      newPassageType.push({
        value: passageTypes.READING.toString(),
        label: "Reading",
      });
      newPassageType.push({
        value: passageTypes.NONREADING.toString(),
        label: "Non Reading",
      });
    }
    setPassageType(newPassageType);
    getContent();
  }

  const bindClassification = () => {
    getClassifications().then((response: any) => {
      const dropOption = response.data.map((values: any) => {
        return {
          label: values?.name,
          value: values?.passageClassificationId,
        };
      });
      setPassageClassification(dropOption);
    });
  };

  function bindDataType() {
    getPassagesDataType().then((response) => {
      let newDataType = [];
      if (response.data.length > 0) {
        newDataType = response.data.map((element) => {
          return {
            value: element.id || 0,
            label: `${element.name}`,
          };
        });
      }
      setDataType(newDataType);
    });
  }

  function bindGrammarType() {
    getPassagesGrammarType().then((response) => {
      let newGrammarType = [];
      if (response.data.length > 0) {
        newGrammarType = response.data.map((element) => {
          return {
            value: element.id || 0,
            label: `${element.name}`,
          };
        });
      }
      setGrammarType(newGrammarType);
    });
  }

  function bindSourceType() {
    getPassagessourceType().then((response) => {
      let newSourceType = [];
      if (response.data.length > 0) {
        newSourceType = response.data.map((element) => {
          return {
            value: element.id || 0,
            label: `${element.name}`,
          };
        });
      }
      setSourceType(newSourceType);
    });
  }

  function bindDifficultyType() {
    getPassagesdifficultyType().then((response) => {
      let newDifficultyType = [];
      if (response.data.length > 0) {
        newDifficultyType = response.data.map((element) => {
          return {
            value: element.id || 0,
            label: `${element.name}`,
          };
        });
      }
      setDifficultyType(newDifficultyType);
    });
  }

  function bindLiteratureType() {
    getPassagesliteratureType().then((response) => {
      let newLiteratureType = [];
      if (response.data.length > 0) {
        newLiteratureType = response.data.map((element) => {
          return {
            value: element.id || 0,
            label: `${element.name}`,
          };
        });
      }
      setLiteratureType(newLiteratureType);
    });
  }

  function bindCategoryType() {
    getPassagesCategory().then((response) => {
      if (response.data.length > 0) {
        let renameKeys: any = [];
        renameKeys = response.data.map((element, i) => {
          return {
            key: element.name + i,
            passageCategoryId: element.passageCategoryId,
            parentId: element.parentId,
            title: `${element.name}`,
            value: element.name + i,
            refid: element.refid,
          };
        });

        /** Code to create nested array from single object based on parent child relationship */
        const obj = {},
          treeFormation: any = [];
        renameKeys.forEach(
          (x) => ((obj[x.passageCategoryId] = x), (x.children = []))
        );
        renameKeys.forEach((x) =>
          x.parentId ? obj[x.parentId].children.push(x) : treeFormation.push(x)
        );

        setCategoryTypeData(renameKeys);
        setCategory(treeFormation);
      }
    });
  }

  function bindCategoryOldType() {
    getPassagesCategoryOld().then((response) => {
      let newCategoryOldType = [];
      if (response.data.length > 0) {
        newCategoryOldType = response.data.map((element) => {
          return {
            value: element.id || 0,
            label: `${element.name}`,
          };
        });
      }
      setcategoryOld(newCategoryOldType);
    });
  }

  const resetClickHandler = () => {
    setResetDropdownFlag(!resetDropdownFlag);
    bindPassage(true);
    setFilterTitle("");
    setFilterEnglishPassageText("");
    setFilterCitation("");
    setIsApproved(true);
    setIsActive(undefined);
    setSelectedSourceType(defaultValue);
    setSelectedGrammar(defaultValue);
    setSelectedDifficulty(defaultValue);
    setSelectedGrade(defaultValue);
    setSelectedLiterature(defaultValue);
    setSelectedCategoryOld(defaultValue);
    setSelectedCategory({
      title: "",
      value: "",
    });
    setSelectedDataType(defaultValue);
    setFilterPassageId(0);
    paginationRef?.current?.onReset();
    pageSizeRef?.current?.onReset();
    setClassification(undefined);
    handleUntagged();
    setSelectedPassageType(defaultValue);
    setselectedContentArea(defaultValue);
    setFilterEnglishPassageText("");
  };

  useEffect(() => {
    bindGrade();
    bindGrammarType();
    bindSourceType();
    bindDifficultyType();
    bindDataType();
    bindLiteratureType();
    bindCategoryType();
    bindCategoryOldType();
    bindPassage();
    bindClassification();
    bindPassageType();
  }, []);

  useEffect(() => {
    if (isLoaded && !isFilter) {
      filterPassage(false, false);
    }
  }, [pageNumber]);

  useEffect(() => {
    filterPassage(false, true);
  }, [selectedTagIds]);

  useEffect(() => {
    if (pageNumber === 1 && !isFilter) {
      filterPassage(false, false);

      setIsLoaded(true);
    } else {
      paginationRef?.current?.onReset();
    }
  }, [pageSize]);

  const filterPassageIdChangeHandler = (e) => {
    setFilterPassageId(e.target.value);
    if (e.target.value === "") {
      bindPassage();
    }
  };

  /** Code to implement input type number to support all browsers */
  useEffect(() => {
    const input = document.getElementById("passageId");
    if (input) {
      input.addEventListener("keypress", (e: any) => {
        const keyValue = e.key;
        if (!e.target.value && e.key == 0) {
          e.preventDefault();
        } else {
          if (!/[0-9.]/.test(keyValue)) {
            e.preventDefault();
          }
        }
      });
    }

    const elem: any = document.getElementsByClassName("ant-select-selector");
    if (elem && elem.length && localStorage.getItem("isDark") === "1") {
      for (let i = 0; i < elem.length; i++) {
        elem[i].style.backgroundColor = "#1A1C23";
        elem[i].style.color = "#ffffff";
        elem[i].style.borderColor = "#6B7280";
      }
    } else if (elem.length) {
      for (let i = 0; i < elem.length; i++) {
        elem[i].style.backgroundColor = "unset";
        elem[i].style.color = "unset";
      }
    }

    window.addEventListener("beforeunload", handleTabClosing);
    window.addEventListener("unload", handleTabClosing);

    return () => {
      window.removeEventListener("beforeunload", handleTabClosing);
      window.removeEventListener("unload", handleTabClosing);
    };
  }, []);
  const handleTabClosing = () => {
    localStorage.setItem("isDark", "0");
  };

  const handleFilterTags = (tags) => {
    const selectedTagIds = tags
      .filter((tag) => tag.selected === true)
      .map((tag) => tag.tagId);
    setSelectedTagIds(selectedTagIds);
  };

  const handleTagClick = (tag) => {
    setSelectedTagIds([tag.tagId]);
  };

  const handleUntagged = () => {
    setSelectedTagIds([0]);
  };

  const exportFn = async () => {
    setLoading(true);
    const passageData: any = {
      filterTitle: filterTitle,
      filterCitation: filterCitation,
      filterGradeId: selectedGrade !== null ? selectedGrade?.value : "0",
      filterDataType: selectedDataType !== null ? selectedDataType?.value : "0",
      filterSourceType:
        selectedSourceType !== null ? selectedSourceType?.value : "0",
      filterDifficulty:
        selectedDifficulty !== null ? selectedDifficulty?.value : "0",
      filterLiterature:
        selectedLiterature !== null ? selectedLiterature?.value : "0",
      filterGrammar: selectedGrammar !== null ? selectedGrammar?.value : "0",

      filterGrade: filterGrade === "" ? "0" : filterGrade,
      filterCategory:
        selectedCategory !== null ? selectedCategory?.passageCategoryId : "0",
      filterCategoryOld:
        selectedCategoryOld !== null ? selectedCategoryOld?.value : "0",
      orderByColumn: orderByColumn,
      sortByDesc: sortByDesc ? "ASC" : "DESC",
      pageSize: defaultPageSize,
      pageNumber: defaultPageNumber,
      isApproved: isApproved,
      isActive: isActive,
      passageId: filterPassageId,
      passageClassificationId: classification,
      filterPassageTypeId:
        selectedPassageType !== null ? selectedPassageType?.value : "0",
      filterEnglishPassageText: filterEnglishPassageText,
    };

    const response = getAllPassages(passageData);
    const data = (await response).data;
    setLoading(false);

    if (data && data.data && data.data.length > 0) {
      childRef?.current?.onDownload(data.data, "passages.csv");
    } else {
      const module = await import("react-toastify");
      module.toast.warning("No records to download");
    }
  };
  const getContent = async () => {
    const service = await import("../../../api/contentArea.service");
    const response = service.getContentArea(999, 1);
    const data = (await response).data;
    let dropdownData = [];
    if (data.data.length > 0) {
      dropdownData = data.data.map((eachContentData) => {
        return {
          value: eachContentData.contentAreaId || 0,
          label: `${eachContentData.name}`,
        };
      });
    }
    setContentArea(dropdownData);
  };
  const handleContenAreaChange = (e) => {
    setselectedContentArea(e);
  };
  return (
    <AllowedTo perform={Permissions.passage_view} no={() => <AccessDenied />}>
      {loading && <Loader />}

      {showDeleteModal && (
        <DeleteModal
          closeDeleteModal={closeDeleteModal}
          deleteRecord={deleteRecordHandler}
        />
      )}
      <div className="flex-1 overflow-auto">
        <div className=" h-auto min-h-half w-full rounded-bl-3xl bg-site-teal px-8  py-8 pt-0 pb-14 mt-7 ">
          <div className="relative  py-1">
            <div className="overlay-image-main pointer-events-none fixed left-0 top-0 w-screen h-screen z-20"></div>
            <div className="flex items-center justify-between">
              <h3 className="text-lg font-light text-gray-900">
                Master Passage List
              </h3>

              <AllowedTo perform={Permissions.passage_create}>
                <button
                  type="button"
                  onClick={() => handleRedirect()}
                  className="inline-flex items-center px-3 py-1 border border-transparent text-sm leading-4 rounded-md shadow-xs text-white dark:text-white bg-primary-color hover:bg-secondary-color focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-color hover:shadow-lg transsition ease-in-out duration-300"
                >
                  <AddIcon className="w-5"></AddIcon>
                  Add Passage
                </button>
              </AllowedTo>
            </div>
            <form action="#" onSubmit={filterHandler}>
              <div className="pt-6 border-b pb-6">
                <div className="grid grid-cols-12 gap-6">
                  <div className="col-span-3 sm:col-span-3">
                    <div className="contentArea">
                      <div>
                        <label className="text-sm text-gray-700">
                          Passage Id
                        </label>
                        <input
                          id="passageId"
                          name="passageId"
                          type="text"
                          placeholder=""
                          className="block mt-1 w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-primary-color focus:border-primary-color dark:focus:border-gray-500 dark:focus:ring-gray-500 dark:bg-custom-black dark:text-white sm:text-sm"
                          value={filterPassageId || ""}
                          onChange={filterPassageIdChangeHandler}
                        />
                      </div>
                    </div>
                  </div>

                  <div className="col-span-3 sm:col-span-3">
                    <div className="contentArea">
                      <div>
                        <label className="text-sm text-gray-700">Title</label>
                        <input
                          id="title"
                          name="title"
                          type="text"
                          className="block mt-1 w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-primary-color focus:border-primary-color dark:focus:border-gray-500 dark:focus:ring-gray-500 dark:bg-custom-black dark:text-white sm:text-sm"
                          value={filterTitle}
                          onChange={filterTitleChangeHandler}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="col-span-3 sm:col-span-3">
                    <div className="contentArea">
                      <div>
                        <label className="text-sm text-gray-700">
                          Citation
                        </label>
                        <input
                          id="citation"
                          name="citation"
                          type="text"
                          className="block w-full mt-1 border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-primary-color focus:border-primary-color dark:focus:border-gray-500 dark:focus:ring-gray-500 dark:bg-custom-black dark:text-white sm:text-sm"
                          value={filterCitation}
                          onChange={citationChangeHandler}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="col-span-3 sm:col-span-3 ">
                    <div className="contentArea">
                      <div>
                        <label className="text-sm text-gray-700">Grade</label>

                        <Select
                          className="w-full mt-1 text-sm"
                          options={grade}
                          onChange={handleGradeChange}
                          value={selectedGrade}
                          isSearchable={true}
                          theme={(theme) => ({
                            ...theme,
                            colors: {
                              ...theme.colors,
                              primary25: "#B3B3B3",
                              primary: "#041E42",
                            },
                          })}
                          styles={{
                            control: (base, state) => ({
                              ...base,
                              background:
                                document.getElementsByClassName("dark")
                                  ?.length > 0
                                  ? "#1A1C23"
                                  : "white",
                              borderColor:
                                document.getElementsByClassName("dark")
                                  ?.length > 0
                                  ? "#6B7280"
                                  : "#D1D5DB",
                              borderWidth: "1px",
                              "&:hover": {
                                borderColor:
                                  state.isFocused &&
                                  document.getElementsByClassName("dark")
                                    ?.length > 0
                                    ? "#6b7280"
                                    : state.isFocused
                                    ? "#4c5563"
                                    : "",
                              },
                            }),
                            singleValue: (base) => ({
                              ...base,
                              color:
                                document.getElementsByClassName("dark")
                                  ?.length > 0
                                  ? "white"
                                  : "#374051",
                            }),
                            input: (base) => ({
                              ...base,
                              color:
                                document.getElementsByClassName("dark")
                                  ?.length > 0
                                  ? "white"
                                  : "",
                            }),
                          }}
                        ></Select>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="grid grid-cols-12 gap-6 mt-5">
                  <div className="col-span-3 sm:col-span-3">
                    <div className="contentArea">
                      <div>
                        <label className="text-sm text-gray-700">
                          Data Type
                        </label>

                        <Select
                          className="w-full mt-1 text-sm"
                          options={dataType}
                          onChange={handleDataTypeChange}
                          value={selectedDataType}
                          isSearchable={true}
                          theme={(theme) => ({
                            ...theme,
                            colors: {
                              ...theme.colors,
                              primary25: "#B3B3B3",
                              primary: "#041E42",
                            },
                          })}
                          styles={{
                            control: (base, state) => ({
                              ...base,
                              background:
                                document.getElementsByClassName("dark")
                                  ?.length > 0
                                  ? "#1A1C23"
                                  : "white",
                              borderColor:
                                document.getElementsByClassName("dark")
                                  ?.length > 0
                                  ? "#6B7280"
                                  : "#D1D5DB",
                              borderWidth: "1px",
                              "&:hover": {
                                borderColor:
                                  state.isFocused &&
                                  document.getElementsByClassName("dark")
                                    ?.length > 0
                                    ? "#6b7280"
                                    : state.isFocused
                                    ? "#4c5563"
                                    : "",
                              },
                            }),
                            singleValue: (base) => ({
                              ...base,
                              color:
                                document.getElementsByClassName("dark")
                                  ?.length > 0
                                  ? "white"
                                  : "#374051",
                            }),
                            input: (base) => ({
                              ...base,
                              color:
                                document.getElementsByClassName("dark")
                                  ?.length > 0
                                  ? "white"
                                  : "",
                            }),
                          }}
                        ></Select>
                      </div>
                    </div>
                  </div>
                  <div className="col-span-3 sm:col-span-3">
                    <label className="text-sm text-gray-700">
                      Grammar Type
                    </label>
                    <Select
                      className="w-full mt-1 text-sm"
                      options={grammarType}
                      onChange={handleGrammarChange}
                      value={selectedGrammar}
                      isSearchable={true}
                      theme={(theme) => ({
                        ...theme,
                        colors: {
                          ...theme.colors,
                          primary25: "#B3B3B3",
                          primary: "#041E42",
                        },
                      })}
                      styles={{
                        control: (base, state) => ({
                          ...base,
                          background:
                            document.getElementsByClassName("dark")?.length > 0
                              ? "#1A1C23"
                              : "white",
                          borderColor:
                            document.getElementsByClassName("dark")?.length > 0
                              ? "#6B7280"
                              : "#D1D5DB",
                          borderWidth: "1px",
                          "&:hover": {
                            borderColor:
                              state.isFocused &&
                              document.getElementsByClassName("dark")?.length >
                                0
                                ? "#6b7280"
                                : state.isFocused
                                ? "#4c5563"
                                : "",
                          },
                        }),
                        singleValue: (base) => ({
                          ...base,
                          color:
                            document.getElementsByClassName("dark")?.length > 0
                              ? "white"
                              : "#374051",
                        }),
                        input: (base) => ({
                          ...base,
                          color:
                            document.getElementsByClassName("dark")?.length > 0
                              ? "white"
                              : "",
                        }),
                      }}
                    ></Select>
                  </div>
                  <div className="col-span-3 sm:col-span-3 ">
                    <div className="contentArea">
                      <div>
                        <label className="text-sm text-gray-700">
                          Source Type
                        </label>

                        <Select
                          className="w-full mt-1 text-sm"
                          options={sourceType}
                          onChange={handleSourceTypeChange}
                          value={selectedSourceType}
                          isSearchable={true}
                          theme={(theme) => ({
                            ...theme,
                            colors: {
                              ...theme.colors,
                              primary25: "#B3B3B3",
                              primary: "#041E42",
                            },
                          })}
                          styles={{
                            control: (base, state) => ({
                              ...base,
                              background:
                                document.getElementsByClassName("dark")
                                  ?.length > 0
                                  ? "#1A1C23"
                                  : "white",
                              borderColor:
                                document.getElementsByClassName("dark")
                                  ?.length > 0
                                  ? "#6B7280"
                                  : "#D1D5DB",
                              borderWidth: "1px",
                              "&:hover": {
                                borderColor:
                                  state.isFocused &&
                                  document.getElementsByClassName("dark")
                                    ?.length > 0
                                    ? "#6b7280"
                                    : state.isFocused
                                    ? "#4c5563"
                                    : "",
                              },
                            }),
                            singleValue: (base) => ({
                              ...base,
                              color:
                                document.getElementsByClassName("dark")
                                  ?.length > 0
                                  ? "white"
                                  : "#374051",
                            }),
                            input: (base) => ({
                              ...base,
                              color:
                                document.getElementsByClassName("dark")
                                  ?.length > 0
                                  ? "white"
                                  : "",
                            }),
                          }}
                        ></Select>
                      </div>
                    </div>
                  </div>
                  <div className="col-span-3 sm:col-span-3">
                    <div className="contentArea">
                      <div>
                        <label className="text-sm text-gray-700">
                          Difficulty Type
                        </label>

                        <Select
                          className="w-full mt-1 text-sm"
                          options={difficultyType}
                          onChange={handleDifficultyChange}
                          value={selectedDifficulty}
                          isSearchable={true}
                          theme={(theme) => ({
                            ...theme,
                            colors: {
                              ...theme.colors,
                              primary25: "#B3B3B3",
                              primary: "#041E42",
                            },
                          })}
                          styles={{
                            control: (base, state) => ({
                              ...base,
                              background:
                                document.getElementsByClassName("dark")
                                  ?.length > 0
                                  ? "#1A1C23"
                                  : "white",
                              borderColor:
                                document.getElementsByClassName("dark")
                                  ?.length > 0
                                  ? "#6B7280"
                                  : "#D1D5DB",
                              borderWidth: "1px",
                              "&:hover": {
                                borderColor:
                                  state.isFocused &&
                                  document.getElementsByClassName("dark")
                                    ?.length > 0
                                    ? "#6b7280"
                                    : state.isFocused
                                    ? "#4c5563"
                                    : "",
                              },
                            }),
                            singleValue: (base) => ({
                              ...base,
                              color:
                                document.getElementsByClassName("dark")
                                  ?.length > 0
                                  ? "white"
                                  : "#374051",
                            }),
                            input: (base) => ({
                              ...base,
                              color:
                                document.getElementsByClassName("dark")
                                  ?.length > 0
                                  ? "white"
                                  : "",
                            }),
                          }}
                        ></Select>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="grid grid-cols-12 gap-6 mt-5">
                  <div className="col-span-3 sm:col-span-3 ">
                    <div className="contentArea">
                      <div>
                        <label className="text-sm text-gray-700">
                          Literature Type
                        </label>

                        <Select
                          className="w-full mt-1 text-sm"
                          options={literatureType}
                          onChange={handleLiteratureChange}
                          value={selectedLiterature}
                          isSearchable={true}
                          theme={(theme) => ({
                            ...theme,
                            colors: {
                              ...theme.colors,
                              primary25: "#B3B3B3",
                              primary: "#041E42",
                            },
                          })}
                          styles={{
                            control: (base, state) => ({
                              ...base,
                              background:
                                document.getElementsByClassName("dark")
                                  ?.length > 0
                                  ? "#1A1C23"
                                  : "white",
                              borderColor:
                                document.getElementsByClassName("dark")
                                  ?.length > 0
                                  ? "#6B7280"
                                  : "#D1D5DB",
                              borderWidth: "1px",
                              "&:hover": {
                                borderColor:
                                  state.isFocused &&
                                  document.getElementsByClassName("dark")
                                    ?.length > 0
                                    ? "#6b7280"
                                    : state.isFocused
                                    ? "#4c5563"
                                    : "",
                              },
                            }),
                            singleValue: (base) => ({
                              ...base,
                              color:
                                document.getElementsByClassName("dark")
                                  ?.length > 0
                                  ? "white"
                                  : "#374051",
                            }),
                            input: (base) => ({
                              ...base,
                              color:
                                document.getElementsByClassName("dark")
                                  ?.length > 0
                                  ? "white"
                                  : "",
                            }),
                          }}
                        ></Select>
                      </div>
                    </div>
                  </div>

                  <div className="col-span-3 sm:col-span-3 ">
                    <div className="contentArea">
                      <div>
                        <label className="text-sm text-gray-700">
                          Category Type
                        </label>
                        <TreeSelect
                          className="w-full mt-1"
                          showSearch
                          style={{ width: "100%" }}
                          dropdownStyle={{ maxHeight: 400, overflow: "auto" }}
                          placeholder=""
                          allowClear
                          treeDefaultExpandAll={true}
                          onChange={handleCategoryChange}
                          treeData={category}
                          value={selectedCategory?.value || ""}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="col-span-3 sm:col-span-3">
                    <label className="text-sm text-gray-700">
                      Category Old Type
                    </label>
                    <Select
                      className="w-full mt-1 text-sm"
                      options={categoryOld}
                      onChange={handleCategoryOldChange}
                      value={selectedCategoryOld}
                      isSearchable={true}
                      theme={(theme) => ({
                        ...theme,
                        colors: {
                          ...theme.colors,
                          primary25: "#B3B3B3",
                          primary: "#041E42",
                        },
                      })}
                      styles={{
                        control: (base, state) => ({
                          ...base,
                          background:
                            document.getElementsByClassName("dark")?.length > 0
                              ? "#1A1C23"
                              : "white",
                          borderColor:
                            document.getElementsByClassName("dark")?.length > 0
                              ? "#6B7280"
                              : "#D1D5DB",
                          borderWidth: "1px",
                          "&:hover": {
                            borderColor:
                              state.isFocused &&
                              document.getElementsByClassName("dark")?.length >
                                0
                                ? "#6b7280"
                                : state.isFocused
                                ? "#4c5563"
                                : "",
                          },
                        }),
                        singleValue: (base) => ({
                          ...base,
                          color:
                            document.getElementsByClassName("dark")?.length > 0
                              ? "white"
                              : "#374051",
                        }),
                        input: (base) => ({
                          ...base,
                          color:
                            document.getElementsByClassName("dark")?.length > 0
                              ? "white"
                              : "",
                        }),
                      }}
                    ></Select>
                  </div>
                  <div className="col-span-3 sm:col-span-3">
                    <label className="text-sm text-gray-700">
                      Classification
                    </label>
                    <Select
                      className="w-full mt-1 text-sm"
                      options={passageClassification}
                      onChange={handlePassageClassificationChange}
                      value={selectedClassification}
                      isSearchable={true}
                      theme={(theme) => ({
                        ...theme,
                        colors: {
                          ...theme.colors,
                          primary25: "#B3B3B3",
                          primary: "#041E42",
                        },
                      })}
                      styles={{
                        control: (base, state) => ({
                          ...base,
                          background:
                            document.getElementsByClassName("dark")?.length > 0
                              ? "#1A1C23"
                              : "white",
                          borderColor:
                            document.getElementsByClassName("dark")?.length > 0
                              ? "#6B7280"
                              : "#D1D5DB",
                          borderWidth: "1px",
                          "&:hover": {
                            borderColor:
                              state.isFocused &&
                              document.getElementsByClassName("dark")?.length >
                                0
                                ? "#6b7280"
                                : state.isFocused
                                ? "#4c5563"
                                : "",
                          },
                        }),
                        singleValue: (base) => ({
                          ...base,
                          color:
                            document.getElementsByClassName("dark")?.length > 0
                              ? "white"
                              : "#374051",
                        }),
                        input: (base) => ({
                          ...base,
                          color:
                            document.getElementsByClassName("dark")?.length > 0
                              ? "white"
                              : "",
                        }),
                      }}
                    ></Select>
                  </div>
                  <div className="col-span-3 sm:col-span-3 ">
                    <div className="contentArea">
                      <div>
                        <label className="text-sm text-gray-700">
                          Passage Type
                        </label>

                        <Select
                          className="w-full mt-1 text-sm"
                          options={passageType}
                          onChange={handlePassageTypeChange}
                          value={selectedPassageType}
                          isSearchable={true}
                          theme={(theme) => ({
                            ...theme,
                            colors: {
                              ...theme.colors,
                              primary25: "#B3B3B3",
                              primary: "#041E42",
                            },
                          })}
                          styles={{
                            control: (base, state) => ({
                              ...base,
                              background:
                                document.getElementsByClassName("dark")
                                  ?.length > 0
                                  ? "#1A1C23"
                                  : "white",
                              borderColor:
                                document.getElementsByClassName("dark")
                                  ?.length > 0
                                  ? "#6B7280"
                                  : "#D1D5DB",
                              borderWidth: "1px",
                              "&:hover": {
                                borderColor:
                                  state.isFocused &&
                                  document.getElementsByClassName("dark")
                                    ?.length > 0
                                    ? "#6b7280"
                                    : state.isFocused
                                    ? "#4c5563"
                                    : "",
                              },
                            }),
                            singleValue: (base) => ({
                              ...base,
                              color:
                                document.getElementsByClassName("dark")
                                  ?.length > 0
                                  ? "white"
                                  : "#374051",
                            }),
                            input: (base) => ({
                              ...base,
                              color:
                                document.getElementsByClassName("dark")
                                  ?.length > 0
                                  ? "white"
                                  : "",
                            }),
                          }}
                        ></Select>
                      </div>
                    </div>
                  </div>
                  <div
                    className={`col-span-3 sm:col-span-3 ${
                      selectedPassageType.value === "2" ? "" : "hidden"
                    }`}
                  >
                    <div className="contentArea">
                      <div>
                        <label className="text-sm text-gray-700">
                          Content Area
                        </label>

                        <Select
                          name="contentArea"
                          value={selectedContentArea}
                          options={contentArea}
                          theme={(theme) => ({
                            ...theme,
                            colors: {
                              ...theme.colors,
                              primary25: "#B3B3B3",
                              primary: "#041E42",
                            },
                          })}
                          onChange={(e) => {
                            handleContenAreaChange(e);
                          }}
                          styles={{
                            control: (base, state) => ({
                              ...base,
                              background:
                                document.getElementsByClassName("dark")
                                  ?.length > 0
                                  ? "#1A1C23"
                                  : "white",
                              borderColor:
                                document.getElementsByClassName("dark")
                                  ?.length > 0
                                  ? "#6B7280"
                                  : "#D1D5DB",
                              borderWidth: "1px",
                              "&:hover": {
                                borderColor:
                                  state.isFocused &&
                                  document.getElementsByClassName("dark")
                                    ?.length > 0
                                    ? "#6b7280"
                                    : state.isFocused
                                    ? "#4c5563"
                                    : "",
                              },
                            }),
                            singleValue: (base) => ({
                              ...base,
                              color:
                                document.getElementsByClassName("dark")
                                  ?.length > 0
                                  ? "white"
                                  : "#374051",
                            }),
                            input: (base) => ({
                              ...base,
                              color:
                                document.getElementsByClassName("dark")
                                  ?.length > 0
                                  ? "white"
                                  : "",
                            }),
                          }}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="col-span-3 sm:col-span-3">
                    <div className="contentArea">
                      <div>
                        <label className="text-sm text-gray-700">
                          Passage Text
                        </label>
                        <input
                          id="englishPassageText"
                          name="englishPassageText"
                          type="text"
                          placeholder=""
                          className="block mt-1 w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-primary-color focus:border-primary-color dark:focus:border-gray-500 dark:focus:ring-gray-500 dark:bg-custom-black dark:text-white sm:text-sm"
                          value={filterEnglishPassageText || ""}
                          onChange={filterEnglishPassageTextChangeHandler}
                        />
                      </div>
                    </div>
                  </div>

                  <div className="col-span-2 flex items-center">
                    <MultiStateButton
                      labels={activeMultiState}
                      onSelect={(e) => setIsActive(e.value)}
                      onReset={resetDropdownFlag}
                    />
                  </div>
                  <div className="col-span-1 sm:col-span-1 flex items-center">
                    <div className="flex items-center contentArea">
                      <input
                        id="isApproved"
                        name="isApproved"
                        type="checkbox"
                        checked={isApproved}
                        onChange={approvedChangeHandler}
                        className=" focus:ring-primary-color h-4 w-4 text-primary-color border-gray-300 rounded"
                      />
                      <label className="ml-1.5 text-sm text-gray-700">
                        Approved
                      </label>
                    </div>
                  </div>
                  <div className="col-span-3 sm:col-span-3 flex items-center">
                    <div className="flex items-center contentArea">
                      <TagSelector
                        label={"Tags"}
                        onTagSelectChange={(tags) => {
                          handleFilterTags(tags);
                        }}
                        onFilterUntagged={() => {
                          handleUntagged();
                        }}
                        removeTag={(tags, tag) => {
                          handleFilterTags(tags);
                        }}
                        mode={TagSelectorMode.Filter}
                        categoryId={0}
                        selectedTagIds={selectedTagIds}
                      />
                    </div>
                  </div>
                </div>

                <div className="flex justify-start">
                  <button
                    type="submit"
                    className="mt-4 inline-flex items-center text-sm text-white dark:text-white gap-2 bg-primary-color hover:bg-secondary-color py-1.5 px-4 rounded-lg"
                  >
                    <FilterIcon className="w-3 h-3"></FilterIcon>
                    <span>Filter</span>
                  </button>
                  <button
                    type="button"
                    onClick={resetClickHandler}
                    className="mt-4 py-1.5 px-4 inline-flex ml-3 items-center text-sm rounded-lg text-gray-700 text-primary-color border border-gray-300 gap-2 bg-white hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-color "
                  >
                    <ResetIcon className="w-3 h-3"></ResetIcon>
                    <span>Reset Filter</span>
                  </button>
                </div>
              </div>
              <div className="flex justify-end">
                <button
                  type="button"
                  onClick={() => exportFn()}
                  className="mt-4 py-1.5 px-4 inline-flex ml-auto items-center text-sm rounded-lg text-gray-700 text-primary-color border border-gray-300 gap-2 bg-white hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-color "
                >
                  <CSVIcon className="w-3 h-3 dark:text-white stroke-current"></CSVIcon>
                  <span>Export</span>
                </button>
                <ExportToCSV ref={childRef} />
              </div>
            </form>

            <div id="dataContainer" className="mt-4">
              <div className="flex flex-col mt-1">
                <div className="-my-2 relative  sm:-mx-6 lg:-mx-8">
                  <div className="py-2 align-middle inline-block min-w-full sm:px-6 lg:px-8">
                    <div className="shadow border-b border-gray-200 sm:rounded-lg">
                      <table className="min-w-full divide-y divide-gray-200">
                        <thead className="bg-primary-color">
                          <tr>
                            <th
                              scope="col"
                              className="px-5 py-2  font-light text-sm text-left text-white dark:text-white tracking-wider w-32 rounded-tl-lg"
                            >
                              <span className="flex">
                                Id
                                <span className="cursor-pointer">
                                  {sortByDesc &&
                                  orderByColumn === "PassageId" ? (
                                    <CaretUpSolidIcon
                                      onClick={() => handleSortBy("PassageId")}
                                      className="w-5 h-5"
                                    ></CaretUpSolidIcon>
                                  ) : (
                                    <CaretDownSolidIcon
                                      onClick={() => handleSortBy("PassageId")}
                                      className="w-5 h-5"
                                    ></CaretDownSolidIcon>
                                  )}
                                </span>
                              </span>
                            </th>

                            <th
                              scope="col"
                              className="px-3 py-2 font-light text-sm text-left text-white dark:text-white tracking-wider w-24"
                            >
                              <span className="flex">
                                Grade
                                <span className="cursor-pointer">
                                  {sortByDesc && orderByColumn === "Grade" ? (
                                    <CaretUpSolidIcon
                                      onClick={() => handleSortBy("Grade")}
                                      className="w-5 h-5"
                                    ></CaretUpSolidIcon>
                                  ) : (
                                    <CaretDownSolidIcon
                                      onClick={() => handleSortBy("Grade")}
                                      className="w-5 h-5"
                                    ></CaretDownSolidIcon>
                                  )}
                                </span>
                              </span>
                            </th>
                            <th
                              scope="col"
                              className="px-3 py-2 font-light  text-sm text-center text-white dark:text-white tracking-wider w-32"
                            >
                              <span className="flex">
                                Title
                                <span className="cursor-pointer">
                                  {sortByDesc && orderByColumn === "Title" ? (
                                    <CaretUpSolidIcon
                                      onClick={() => handleSortBy("Title")}
                                      className="w-5 h-5"
                                    ></CaretUpSolidIcon>
                                  ) : (
                                    <CaretDownSolidIcon
                                      onClick={() => handleSortBy("Title")}
                                      className="w-5 h-5"
                                    ></CaretDownSolidIcon>
                                  )}
                                </span>
                              </span>
                            </th>
                            <th
                              scope="col"
                              className="px-3 py-2 font-light pl-6 text-sm text-center text-white dark:text-white tracking-wider w-32"
                            >
                              <span className="flex">
                                Citation
                                <span className="cursor-pointer">
                                  {sortByDesc &&
                                  orderByColumn === "Citation" ? (
                                    <CaretUpSolidIcon
                                      onClick={() => handleSortBy("Citation")}
                                      className="w-5 h-5"
                                    ></CaretUpSolidIcon>
                                  ) : (
                                    <CaretDownSolidIcon
                                      onClick={() => handleSortBy("Citation")}
                                      className="w-5 h-5"
                                    ></CaretDownSolidIcon>
                                  )}
                                </span>
                              </span>
                            </th>
                            <th
                              scope="col"
                              className="px-3 py-2 whitespace-nowrap font-light text-sm text-center text-white dark:text-white tracking-wider w-48"
                            >
                              <span className="flex">
                                Grammar name
                                <span className="cursor-pointer">
                                  {sortByDesc &&
                                  orderByColumn === "GrammarName" ? (
                                    <CaretUpSolidIcon
                                      onClick={() =>
                                        handleSortBy("GrammarName")
                                      }
                                      className="w-5 h-5"
                                    ></CaretUpSolidIcon>
                                  ) : (
                                    <CaretDownSolidIcon
                                      onClick={() =>
                                        handleSortBy("GrammarName")
                                      }
                                      className="w-5 h-5"
                                    ></CaretDownSolidIcon>
                                  )}
                                </span>
                              </span>
                            </th>
                            <th
                              scope="col"
                              className="px-3 py-2 font-light text-sm text-center text-white dark:text-white tracking-wider w-24"
                            >
                              <span className="flex">
                                Difficulty
                                <span className="cursor-pointer">
                                  {sortByDesc &&
                                  orderByColumn === "DifficultyName" ? (
                                    <CaretUpSolidIcon
                                      onClick={() =>
                                        handleSortBy("DifficultyName")
                                      }
                                      className="w-5 h-5"
                                    ></CaretUpSolidIcon>
                                  ) : (
                                    <CaretDownSolidIcon
                                      onClick={() =>
                                        handleSortBy("DifficultyName")
                                      }
                                      className="w-5 h-5"
                                    ></CaretDownSolidIcon>
                                  )}
                                </span>
                              </span>
                            </th>
                            <th
                              scope="col"
                              className="px-3 py-2 font-light text-sm text-center text-white dark:text-white tracking-wider w-24"
                            >
                              <span className="flex">
                                Literature
                                <span className="cursor-pointer">
                                  {sortByDesc &&
                                  orderByColumn === "LiteratureName" ? (
                                    <CaretUpSolidIcon
                                      onClick={() =>
                                        handleSortBy("LiteratureName")
                                      }
                                      className="w-5 h-5"
                                    ></CaretUpSolidIcon>
                                  ) : (
                                    <CaretDownSolidIcon
                                      onClick={() =>
                                        handleSortBy("LiteratureName")
                                      }
                                      className="w-5 h-5"
                                    ></CaretDownSolidIcon>
                                  )}
                                </span>
                              </span>
                            </th>
                            <th
                              scope="col"
                              className="px-3 py-2 font-light whitespace-nowrap text-sm text-center text-white dark:text-white tracking-wider w-24"
                            >
                              Lexile
                            </th>
                            <th
                              scope="col"
                              className="px-3 py-2 font-light text-sm text-center text-white dark:text-white tracking-wider w-24"
                            >
                              <span className="flex">
                                Category
                                <span className="cursor-pointer">
                                  {sortByDesc &&
                                  orderByColumn === "categoryName" ? (
                                    <CaretUpSolidIcon
                                      onClick={() =>
                                        handleSortBy("categoryName")
                                      }
                                      className="w-5 h-5"
                                    ></CaretUpSolidIcon>
                                  ) : (
                                    <CaretDownSolidIcon
                                      onClick={() =>
                                        handleSortBy("categoryName")
                                      }
                                      className="w-5 h-5"
                                    ></CaretDownSolidIcon>
                                  )}
                                </span>
                              </span>
                            </th>
                            <th
                              scope="col"
                              className="px-3 py-2 whitespace-nowrap	 font-light text-sm text-center text-white dark:text-white tracking-wider w-48"
                            >
                              <span className="flex">
                                Category (Old)
                                <span className="cursor-pointer">
                                  {sortByDesc &&
                                  orderByColumn === "categoryOldName" ? (
                                    <CaretUpSolidIcon
                                      onClick={() =>
                                        handleSortBy("categoryOldName")
                                      }
                                      className="w-5 h-5"
                                    ></CaretUpSolidIcon>
                                  ) : (
                                    <CaretDownSolidIcon
                                      onClick={() =>
                                        handleSortBy("categoryOldName")
                                      }
                                      className="w-5 h-5"
                                    ></CaretDownSolidIcon>
                                  )}
                                </span>
                              </span>
                            </th>

                            <th
                              scope="col"
                              className="px-3 py-2 font-light whitespace-wrap text-sm text-left text-white dark:text-white w-60"
                            >
                              <span className="flex">
                                Passage
                                <span className="cursor-pointer">
                                  {sortByDesc &&
                                  orderByColumn === "englishPassage" ? (
                                    <CaretUpSolidIcon
                                      onClick={() =>
                                        handleSortBy("englishPassage")
                                      }
                                      className="w-5 h-5"
                                    ></CaretUpSolidIcon>
                                  ) : (
                                    <CaretDownSolidIcon
                                      onClick={() =>
                                        handleSortBy("englishPassage")
                                      }
                                      className="w-5 h-5"
                                    ></CaretDownSolidIcon>
                                  )}
                                </span>
                              </span>
                            </th>

                            <th
                              scope="col"
                              className="px-3 py-2 font-light text-sm text-center text-white dark:text-white tracking-wider rounded-tr-lg  w-5"
                            ></th>
                          </tr>
                        </thead>
                        <tbody>
                          {passageList.map((passages, index) => (
                            <>
                              <tr
                                key={passages.passageId}
                                className={
                                  index % 2 === 0 ? "bg-white" : "bg-gray-100"
                                }
                              >
                                <td className="relative">
                                  {passages.isActive ? (
                                    <span className="mr-1 mt-1 h-full w-0.5 bg-green-500 rounded-md inline-block absolute top-0 left-1.5"></span>
                                  ) : (
                                    <span className="mr-1 mt-1 h-full w-0.5 bg-red-500 rounded-md inline-block absolute top-0 left-1.5"></span>
                                  )}
                                  <Link
                                    to={constant.EDITPASSAGE?.replace(
                                      ":id",
                                      passages.passageId.toString()
                                    )}
                                    className="cursor-pointer font-medium pl-6 text-indigo-600 hover:text-indigo-500 hover:underline"
                                  >
                                    {passages.passageId}
                                  </Link>
                                </td>

                                <td className="px-3 py-2  text-sm text-center font-normal text-gray-500">
                                  <Link
                                    to={constant.EDITGRADE.replace(
                                      ":id",
                                      passages.gradeId
                                        ? passages.gradeId.toString()
                                        : ""
                                    )}
                                    className="cursor-pointer font-medium pl-6 text-indigo-600 hover:text-indigo-500 hover:underline"
                                  >
                                    {passages.gradeName}
                                  </Link>
                                </td>
                                <td className=" py-2 text-sm relative font-normal text-gray-500">
                                  <span className="group">
                                    <Link
                                      to={constant.EDITPASSAGE?.replace(
                                        ":id",
                                        passages.passageId.toString()
                                      )}
                                      className="cursor-pointer font-medium text-indigo-600 hover:text-indigo-500 hover:underline"
                                    >
                                      {passages.title}
                                    </Link>
                                    <div
                                      style={
                                        index == 0 || index == 1
                                          ? { top: "40px", left: "80px" }
                                          : { top: "-92px", left: "60px" }
                                      }
                                      className="absolute w-100 bg-blue-50 left-0 hidden group-hover:block transition-all shadow-lg border border-blue-200 p-4 rounded-lg z-20 "
                                    >
                                      <div className="flex flex-col text-sm space-y-1.5">
                                        <div className="flex bg-white/50 p-1">
                                          <div className="w-32 text-gray-700">
                                            Literature
                                          </div>
                                          <div className="w-full">
                                            {passages.literatureName}
                                          </div>
                                        </div>
                                        <div className="flex p-1">
                                          <div className="w-32 text-gray-700">
                                            Category
                                          </div>
                                          <div className="w-full">
                                            {passages.categoryName}
                                          </div>
                                        </div>
                                        <div className="flex bg-white/50 p-1">
                                          <div className="w-32 text-gray-700">
                                            Category Old
                                          </div>
                                          <div className="w-full">
                                            {passages.categoryOldName}
                                          </div>
                                        </div>
                                        <div className="flex p-1">
                                          <div className="w-32 text-gray-700">
                                            Passage
                                          </div>
                                          <div className="w-full">
                                            <Tooltip
                                              text={passages.englishPassage?.replace(
                                                /<[^>]+>/g,
                                                ""
                                              )}
                                            />
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </span>
                                </td>
                                <td className="py-2 pl-6 text-sm  font-normal text-gray-500">
                                  {passages.citation}
                                </td>
                                <td className="px-3 py-2  text-sm text-left font-normal text-gray-500">
                                  {passages.grammerName}
                                </td>
                                <td className="px-3 py-2  text-sm text-left font-normal text-gray-500">
                                  {passages.difficultyName}
                                </td>
                                <td className="px-3 py-2  text-sm text-left font-normal text-gray-500">
                                  {passages.literatureName}
                                </td>
                                <td className="px-3 py-2  text-sm text-center font-normal text-gray-500">
                                  {passages.lexileLevel}
                                </td>
                                <td className="px-3 py-2  text-sm text-left font-normal text-gray-500">
                                  {passages.categoryName}
                                </td>
                                <td className="px-3 py-2  text-sm text-left font-normal text-gray-500">
                                  {passages.categoryOldName}
                                </td>
                                <td className="px-3 py-2  text-sm textleft font-normal text-gray-500">
                                  <Tooltip
                                    length={35}
                                    text={passages.englishPassage?.replace(
                                      /<[^>]+>/g,
                                      ""
                                    )}
                                  />
                                </td>

                                <td className="flex justify-end items-center px-3 py-2 text-sm text-center font-normal text-gray-700">
                                  <div className="flex space-x-2 justify-center items-center">
                                    {passages.isApproved ? (
                                      <ApproveIcon />
                                    ) : (
                                      <Disapprove />
                                    )}

                                    <Menu
                                      as="div"
                                      className="relative flex justify-end items-center"
                                    >
                                      <Menu.Button className="h-7 bg-white inline-flex items-center justify-center text-gray-400 rounded-full hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-bg-primary-color">
                                        <span className="sr-only">
                                          Open options
                                        </span>
                                        <DotsVerticalIcon
                                          className="w-5 h-5"
                                          aria-hidden="true"
                                        />
                                      </Menu.Button>
                                      <Transition
                                        as={Fragment}
                                        enter="transition ease-out duration-100"
                                        enterFrom="transform opacity-0 scale-95"
                                        enterTo="transform opacity-100 scale-100"
                                        leave="transition ease-in duration-75"
                                        leaveFrom="transform opacity-100 scale-100"
                                        leaveTo="transform opacity-0 scale-95"
                                      >
                                        <Menu.Items className="mx-3 origin-top-right absolute right-7 top-0 w-48 mt-1 rounded-md shadow-lg z-10 bg-white ring-1 ring-black ring-opacity-5 divide-y divide-gray-200 focus:outline-none">
                                          <AllowedTo
                                            perform={Permissions.passage_modify}
                                          >
                                            {" "}
                                            <div className="py-1">
                                              <Menu.Item>
                                                {({ active }) => (
                                                  <a
                                                    onClick={() =>
                                                      handleRedirect(passages)
                                                    }
                                                    className={classNames(
                                                      active
                                                        ? "bg-gray-100 text-gray-900"
                                                        : "text-gray-700",
                                                      "group flex items-center px-4 py-2 text-sm"
                                                    )}
                                                  >
                                                    <EditIcon className="mr-3 h-5 w-5 text-xs font-light cursor-pointer hover:text-secondary-color transaction ease-in-out duration-300" />
                                                    Edit
                                                  </a>
                                                )}
                                              </Menu.Item>
                                            </div>
                                          </AllowedTo>

                                          <AllowedTo
                                            perform={Permissions.passage_delete}
                                          >
                                            <div className="py-1">
                                              <Menu.Item>
                                                {({ active }) => (
                                                  <a
                                                    onClick={(e) =>
                                                      handleDeletePassage(
                                                        e,
                                                        passages.passageId,
                                                        passages.userId
                                                      )
                                                    }
                                                    className={classNames(
                                                      active
                                                        ? "bg-gray-100 text-gray-900"
                                                        : "text-gray-700",
                                                      "group flex items-center px-4 py-2 text-sm"
                                                    )}
                                                  >
                                                    <DeleteIcon className="mr-3 h-5 w-5 text-xs font-light cursor-pointer hover:text-red-500 transaction ease-in-out duration-300" />
                                                    Delete
                                                  </a>
                                                )}
                                              </Menu.Item>
                                            </div>
                                          </AllowedTo>
                                        </Menu.Items>
                                      </Transition>
                                    </Menu>
                                  </div>
                                </td>
                              </tr>
                              <tr
                                className={
                                  index % 2 === 0 ? "bg-white" : "bg-gray-100"
                                }
                              >
                                <td className="pl-6 whitespace-wrap text-sm text-left font-normal text-gray-500 relative">
                                  {passages.isActive ? (
                                    <span className="mr-1 mb-2 h-full w-0.5 bg-green-500 rounded-md inline-block absolute top-0 left-1.5"></span>
                                  ) : (
                                    <span className="mr-1 mb-2 h-full w-0.5 bg-red-500 rounded-md inline-block absolute top-0 left-1.5"></span>
                                  )}
                                </td>
                                <td colSpan={11}>
                                  {passages.tags.map((tag) => (
                                    <li
                                      key={tag.tagId}
                                      className={`inline-block bg-[${
                                        tag.color
                                      }] 
                                rounded-full text-xs shadow-sm py-0.5 px-3  whitespace-nowrap mx-1 mb-2 cursor-pointer
                               ${
                                 TagColor.isDark(tag.color)
                                   ? "text-white"
                                   : "text-black"
                               }
                                `}
                                      onClick={() => {
                                        handleTagClick(tag);
                                      }}
                                    >
                                      {tag.name}
                                    </li>
                                  ))}
                                </td>
                              </tr>
                            </>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
                <div
                  className={`flex justify-between items-center ${
                    passageList.length === 0 ? "hidden" : ""
                  }`}
                >
                  <Pagination
                    pages={totalPages}
                    setPageNumber={setPageNumber}
                    ref={paginationRef}
                  />
                  <span>
                    <span className="text-sm pr-4 ml-auto text-left-700">
                      Showing {pageNumber} to{" "}
                      {totalRecords < pageSize ? totalRecords : pageSize} of{" "}
                      {totalRecords} results
                    </span>

                    <SelectPageSize
                      setPageSize={setPageSize}
                      type={"second"}
                      ref={pageSizeRef}
                      defaultPage={defaultPageSize}
                    />
                  </span>
                </div>

                {passageList.length === 0 && (
                  <p className="p-2">No Records Found</p>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </AllowedTo>
  );
};

export default Passage;
